export const CONFIG = {
  EMAIL_DRAFT_AUTOSAVE: import.meta.env.VITE_EMAIL_DRAFT_AUTOSAVE,
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  GLITCHTIP_DSN:
    import.meta.env.VITE_GLITCHTIP_DSN ??
    'https://fa61077311ec48178e75d4cede608cd2@glitchtip.elivion.io/1',
  HOST: import.meta.env.VITE_HOST_URL,
  IS_PROD: import.meta.env.VITE_ENVIRONMENT === 'production',
  JSESSION: import.meta.env.VITE_SESSION_ID,
  PERFORMANCE_SCAN: import.meta.env.VITE_PERFORMANCE_SCAN,
};
